import { render, staticRenderFns } from "./reject-with-reason-modal.vue?vue&type=template&id=5dbc0472&scoped=true"
import script from "./reject-with-reason-modal.vue?vue&type=script&lang=js"
export * from "./reject-with-reason-modal.vue?vue&type=script&lang=js"
import style0 from "./reject-with-reason-modal.vue?vue&type=style&index=0&id=5dbc0472&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbc0472",
  null
  
)

export default component.exports